import React from 'react'
import { useStyles } from './styles'

interface CustomButtonProps {
  onClick?: Function
}

export const Actions: React.FC<CustomButtonProps> = ({ onClick }) => {
  const classes = useStyles()

  return (
    <button className={classes.actionsButton} onClick={() => onClick && onClick()}>
      <svg width='31' height='27' viewBox='0 0 31 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g filter='url(#filter0_d_595_7247)'>
          <rect x='4' y='4' width='23' height='19' rx='2' fill='#FAFAFA' shapeRendering='crispEdges' />
          <path
            d='M17.0789 13.5C17.0789 14.3297 16.3734 15 15.5 15C14.6266 15 13.9211 14.3297 13.9211 13.5C13.9211 12.6703 14.6266 12 15.5 12C16.3734 12 17.0789 12.6703 17.0789 13.5ZM21.4211 12C20.5477 12 19.8421 12.6703 19.8421 13.5C19.8421 14.3297 20.5477 15 21.4211 15C22.2944 15 23 14.3297 23 13.5C23 12.6703 22.2944 12 21.4211 12ZM9.57895 12C8.70559 12 8 12.6703 8 13.5C8 14.3297 8.70559 15 9.57895 15C10.4523 15 11.1579 14.3297 11.1579 13.5C11.1579 12.6703 10.4523 12 9.57895 12Z'
            fill='black'
          />
        </g>
        <defs>
          <filter
            id='filter0_d_595_7247'
            x='0'
            y='0'
            width='31'
            height='27'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0.370833 0 0 0 0 0.352406 0 0 0 0 0.349201 0 0 0 0.15 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_595_7247' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_595_7247' result='shape' />
          </filter>
        </defs>
      </svg>
    </button>
  )
}
